export default __webpack_public_path__ + "static/media/section1-process-bg2.0c9efd67.png";